// Synthesised game sounds (Web Audio, no files): dice rattle, pawn steps, capture, win.
let ctx = null;
const KEY = "bkm_sound";
const listeners = new Set();

export const soundOn = () => localStorage.getItem(KEY) !== "off";
export const setSoundOn = (on) => {
  localStorage.setItem(KEY, on ? "on" : "off");
  listeners.forEach((f) => f(on));
};
export const onSoundChange = (f) => { listeners.add(f); return () => listeners.delete(f); };

const ac = () => {
  if (!ctx) {
    const C = window.AudioContext || window.webkitAudioContext;
    if (!C) return null;
    ctx = new C();
  }
  if (ctx.state === "suspended") ctx.resume();
  return ctx;
};

// Mobile browsers only allow audio after a user gesture.
if (typeof window !== "undefined") {
  const unlock = () => { ac(); window.removeEventListener("pointerdown", unlock); };
  window.addEventListener("pointerdown", unlock);
}

const click = (a, t, freq, dur, vol) => {
  const len = Math.floor(a.sampleRate * dur);
  const buf = a.createBuffer(1, len, a.sampleRate);
  const d = buf.getChannelData(0);
  for (let i = 0; i < len; i++) d[i] = (Math.random() * 2 - 1) * Math.pow(1 - i / len, 3);
  const src = a.createBufferSource();
  src.buffer = buf;
  const f = a.createBiquadFilter();
  f.type = "bandpass"; f.frequency.value = freq; f.Q.value = 1.2;
  const g = a.createGain();
  g.gain.value = vol;
  src.connect(f).connect(g).connect(a.destination);
  src.start(t);
};

const tone = (a, t, freq, dur, vol, type = "sine") => {
  const o = a.createOscillator();
  const g = a.createGain();
  o.type = type; o.frequency.setValueAtTime(freq, t);
  g.gain.setValueAtTime(vol, t);
  g.gain.exponentialRampToValueAtTime(0.001, t + dur);
  o.connect(g).connect(a.destination);
  o.start(t); o.stop(t + dur);
};

const run = (fn) => {
  if (!soundOn()) return;
  const a = ac();
  if (a) fn(a, a.currentTime + 0.01);
};

export const playDice = () => run((a, t) => {
  for (let i = 0; i < 9; i++) click(a, t + i * 0.045 + Math.random() * 0.02, 1800 + Math.random() * 1600, 0.05, 0.5);
  click(a, t + 0.5, 900, 0.09, 0.8);
});

export const playSteps = (n) => run((a, t) => {
  for (let i = 0; i < Math.max(1, Math.min(n, 6)); i++) {
    click(a, t + i * 0.11, 1200, 0.04, 0.6);
    tone(a, t + i * 0.11, 520 + i * 40, 0.06, 0.08, "triangle");
  }
});

export const playCapture = () => run((a, t) => {
  tone(a, t, 440, 0.12, 0.2, "square");
  tone(a, t + 0.1, 220, 0.25, 0.2, "square");
});

export const playHome = () => run((a, t) => {
  [660, 880, 1320].forEach((f, i) => tone(a, t + i * 0.09, f, 0.2, 0.12));
});

export const playWin = () => run((a, t) => {
  [523, 659, 784, 1047].forEach((f, i) => tone(a, t + i * 0.13, f, 0.35, 0.15, "triangle"));
});
